import { createFileRoute } from '@tanstack/react-router';
import { FeedPage } from '../components/feed/feed-page.js';
import { validateFeedSearch } from '../lib/feed-search.js';

export const Route = createFileRoute('/$workspaceSlug/feed')({
  component: FeedPage,
  validateSearch: validateFeedSearch,
});
